"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDataClient = void 0;
class UserDataClient {
    constructor(authService, stage) {
        this.authService = authService;
        this.stage = stage;
        this.resourceHostId = `myvw-user-data-service-${stage}`;
    }
    async getUserData(vin, pictures, roles) {
        let response;
        if (roles) {
            response = await this.authService.get(this.resourceHostId, `vehicles/${vin}/users?pictures=${pictures !== null && pictures !== void 0 ? pictures : false}&roles=${roles}`);
        }
        else {
            response = await this.authService.get(this.resourceHostId, `vehicles/${vin}/users?pictures=${pictures !== null && pictures !== void 0 ? pictures : false}`);
        }
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return await response.json();
    }
}
exports.UserDataClient = UserDataClient;
//# sourceMappingURL=UserDataClient.js.map